import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { Button } from 'primereact/button';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';

import classNames from 'classnames';
import { FaCheck, FaTimes } from 'react-icons/fa';
import AppCard from '../../../../../components/appCard';
import { useInfo } from '../../../../../context/infoContext';
import { ApiAdimplencia } from '../../../../../services/api';

import { associado_id, userInfo } from '../../../../../services/authHandlers';

export default function GerenciarParametros() {
    const [parametrosData, setParametrosData] = useState({});
    const [loading, setLoading] = useState(true);
    const [parametrosId, setParametrosId] = useState('');
    const [parametrosJuros, setParametrosJuros] = useState(0);
    const [parametrosMulta, setParametrosMulta] = useState(0);
    const [parametrosInadimplencia, setParametrosInadimplencia] = useState(30);
    const [parametrosExpiracao, setParametrosExpiracao] = useState(30);
    const [parametrosFechamento, setParametrosFechamento] = useState(10);
    const [parametrosTipoFechamento, setParametrosTipoFechamento] = useState('');
    const [parametrosTaxa, setParametrosTaxa] = useState('');
    const [parametrosProtesto, setParametrosProtesto] = useState(null);
    const [parametrosCancelamento, setParametrosCancelamento] = useState(2)
    const [requestURL, setRequestURL] = useState('/credorParametro');

    const [showConfirm, setShowConfirm] = useState(false);

    const { credorData } = useInfo();

    useEffect(() => {
        getParametrosData()
    }, [credorData])

    //templates

    // const fechamentoOptions = [
    //     { label: 'Fatura', value: 'fatura' },
    // ]

    const taxaOptions = [
        { label: 'Cliente', value: 'consumidor' },
        { label: 'Empresa', value: 'credor' },
    ]

    const footerDialog = (
        <div className='flex justify-end gap-2'>
            <Button
                label='Não'
                severity='danger'
                icon={<FaTimes className='h-5 mr-2' style={{ marginTop: '3px' }} />}
                onClick={() => setShowConfirm(false)}
            />
            <Button
                label='Sim'
                severity='success'
                icon={<FaCheck className='h-5 mr-2' style={{ marginTop: '3px' }} />}
                onClick={updateParams}
            />
        </div>
    )

    //functions

    function handleUpdate(event) {
        event.preventDefault();
        const associado_operador_id = userInfo.associado_id || associado_id

        setParametrosData({
            cre_parametro_juros: parametrosJuros === '' ? null : parametrosJuros,
            cre_parametro_multa: parametrosMulta === '' ? null : parametrosMulta,
            cre_parametro_inadimplencia: parametrosInadimplencia === '' ? null : parametrosInadimplencia,
            cre_parametro_expiracao_boleto: parametrosExpiracao === '' ? null : parametrosExpiracao,
            cre_parametro_fechamento: parametrosFechamento === '' ? null : parametrosFechamento,
            cre_parametro_fechamento_tipo: parametrosTipoFechamento,
            cre_parametro_taxa: parametrosTaxa,
            cre_parametro_protesto: parametrosProtesto === '' ? null : parametrosProtesto,
            credor_id: credorData.credor_id,
            usuario_id: credorData.credor_usuario_id,
            associado_id: associado_operador_id,
            cre_parametro_id: !parametrosId ? '' : parametrosId,
            qtd_inadimplencia_inativacao: parametrosCancelamento|| 0
        })

        setShowConfirm(true)
    }

    //chamada de api

    async function getParametrosData() {
        setLoading(true);

        if (credorData) {
            try {
                const { data } = await ApiAdimplencia.get(`/credorParametro/buscar/${credorData.credor_id}`)

                //console.log(data)
                if (data) {
                    setRequestURL('/credorParametro/atualizar')
                    setParametrosData(data ? data : {})
                    setParametrosId(data.cre_parametro_id === null ? '' : data.cre_parametro_id)
                    setParametrosJuros(data.cre_parametro_juros === null ? '' : Number(data.cre_parametro_juros).toFixed(0))
                    setParametrosMulta(data.cre_parametro_multa === null ? '' : Number(data.cre_parametro_multa).toFixed(0))
                    setParametrosInadimplencia(data.cre_parametro_inadimplencia === null ? '' : data.cre_parametro_inadimplencia)
                    setParametrosExpiracao(data.cre_parametro_expiracao_boleto === null ? '' : data.cre_parametro_expiracao_boleto)
                    setParametrosFechamento(data.cre_parametro_fechamento === null ? '' : data.cre_parametro_fechamento)
                    setParametrosTaxa(data.cre_parametro_taxa === null ? '' : data.cre_parametro_taxa)
                    setParametrosTipoFechamento('fatura')
                    setParametrosProtesto(data.cre_parametro_protesto === null ? '' : data.cre_parametro_protesto)
                    setParametrosCancelamento(data.qtd_inadimplencia_inativacao || 0)
                } else setRequestURL('/credorParametro/inserir')

            } catch (error) {
                console.log(error.response)
                toast.error('Houve um erro ao carregar parâmetros.')
            } finally {
                setLoading(false);
            }
        }
    }

    async function updateParams() {
        setShowConfirm(false)
        try {
            let returned;
            if (requestURL.includes('inserir'))
                returned = await ApiAdimplencia.post(requestURL, parametrosData)
            else
                returned = await ApiAdimplencia.put(requestURL, parametrosData)

            //console.log(returned.data)
            toast.success('Parâmetros atualizados com sucesso!')
        } catch (error) {
            console.log(error.response)
            toast.error('Houve um erro ao atualizar os parâmetros.')
        }
    }

    const fieldClass = 'h-10 min-h-[2.5rem] w-full rounded-md border border-gray-400 dark:border-blue-900/40 bg-white dark:bg-gray-900 px-3 py-2 text-gray-700 dark:text-white/80';
    const labelClass = 'text-xs font-medium text-gray-700 dark:text-white/80 block mb-0.5';
    const hintClass = 'text-xs text-gray-500 dark:text-gray-400 mt-0.5 mb-0.5';

    return (
        <AppCard className="flex flex-col !px-5 !py-4">
            {showConfirm && (
                <ConfirmDialog
                    footer={footerDialog}
                    onHide={() => setShowConfirm(false)}
                    header={`Os parametros serão alterados`}
                    message={`Confirme para alterar os parametros`}
                    className='w-11/12 sm:w-9/12 md:w-1/2 lg:w-2/5'
                    visible
                />
            )}
            <div className="w-full flex flex-col">
                <div className="flex items-center justify-between gap-3 pb-2.5 border-b border-gray-200 dark:border-blue-900/40 mb-3">
                    <h3 className="text-lg font-semibold text-gray-800 dark:text-white/90">Parâmetros</h3>
                </div>
                <form onSubmit={e => handleUpdate(e)} className="flex flex-col gap-2.5">
                        <div className="flex flex-col gap-0.5">
                            <label htmlFor="parametros_juros" className={labelClass}>Juros (%)</label>
                            <span className={hintClass}>Ex.: 1%</span>
                            <InputText
                                className={fieldClass}
                                id="parametros_juros"
                                name="parametros_juros"
                                placeholder="ex: 1"
                                value={parametrosJuros}
                                onChange={e => setParametrosJuros(String(e.target.value))}
                                required
                                locale="pt-BR"
                                min={0}
                                max={100}
                                type="number"
                            />
                        </div>

                        <div className="flex flex-col gap-0.5">
                            <label htmlFor="parametros_multa" className={labelClass}>Multa (%)</label>
                            <span className={hintClass}>Ex.: 2%</span>
                            <InputText
                                className={fieldClass}
                                id="parametros_multa"
                                name="parametros_multa"
                                placeholder="ex: 2"
                                value={parametrosMulta}
                                onChange={e => setParametrosMulta(String(e.target.value))}
                                required
                                locale="pt-BR"
                                min={0}
                                max={100}
                                type="number"
                            />
                        </div>

                        <div className="flex flex-col gap-0.5">
                            <label htmlFor="parametros_fechamento" className={labelClass}>Dia da emissão de boleto</label>
                            <span className={hintClass}>Ex: 10 (dias antes do vencimento)</span>
                            <InputText
                                className={fieldClass}
                                id="parametros_fechamento"
                                name="parametros_fechamento"
                                placeholder="ex: 10"
                                value={parametrosFechamento}
                                onChange={e => setParametrosFechamento(e.target.value)}
                                required
                                locale="pt-BR"
                                min={0}
                                type="number"
                            />
                        </div>

                        {/* <div className="flex flex-row mt-5">
                            <div className="w-full md:w-1/2">
                                <label htmlFor="parametros_fechamento_tipo"><b>Tipo de Fechamento</b></label>
                                <p>selecione um tipo</p>
                            </div>
                            <div className="w-full md:w-1/2">
                                <Dropdown
                                    id="parametros_fechamento_tipo"
                                    name="parametros_fechamento_tipo"
                                    placeholder="Selecione"
                                    value={parametrosTipoFechamento}
                                    options={fechamentoOptions}
                                    onChange={e => {
                                        setParametrosTipoFechamento(e.target.value)
                                    }}
                                    required
                                />
                            </div>
                        </div> */}

                        <div className="flex flex-col gap-0.5">
                            <label htmlFor="parametros_taxa_servico" className={labelClass}>Taxa do boleto</label>
                            <span className={hintClass}>Responsável pelo pagamento</span>
                            <Dropdown
                                    className="parametrosAdimplencia w-full h-10 min-h-[2.5rem]"
                                    pt={{
                                        root: ({ props }) => ({
                                            className: classNames(
                                                'cursor-pointer inline-flex relative select-none',
                                                'bg-white border border-gray-400 transition-colors duration-200 ease-in-out rounded-md',
                                                'dark:bg-gray-900 dark:border-blue-900/40 dark:hover:border-blue-300',
                                                'hover:border-blue-500 focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[0_0_0_0.2rem_rgba(147,197,253,0.5)]',
                                                {
                                                    'opacity-60 select-none pointer-events-none cursor-default': props.disabled,
                                                    'w-full md:w-56': !props.className,
                                                    'lg:w-1/2 w-full': props.className === 'painelAdimplencia',
                                                    'w-full': props.className === 'parametrosAdimplencia'
                                                }
                                            )
                                        }),
                                        filtercontainer: 'relative',
                                        filterinput: {
                                            className: classNames(
                                                'pr-7 -mr-7 ',
                                                'w-full',
                                                'font-sans text-base text-gray-700 bg-white py-3 px-7 border border-gray-300 transition duration-200 rounded-lg appearance-none',
                                                'dark:bg-gray-900 dark:border-blue-900/40 dark:hover:border-blue-300 dark:text-white/80',
                                                'hover:border-blue-500 focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[0_0_0_0.2rem_rgba(147,197,253,0.5)]'
                                            )
                                        },
                                        filtericon: '-mt-2 ml-2 absolute top-1/2',
                                        itemLabel: 'font-semibold',
                                        item: ({ context }) => ({
                                            className: classNames(
                                                'cursor-pointer font-normal overflow-hidden relative whitespace-nowrap',
                                                'm-0 p-3 border-0  transition-shadow duration-200 rounded-none',
                                                'dark:text-white/80 dark:hover:bg-gray-600/80 dark:hover:text-white',
                                                'hover:text-gray-900 hover:bg-gray-200 hover:font-bold',
                                                {
                                                    'text-gray-700': !context.focused && !context.selected,
                                                    'bg-gray-300 text-gray-700 dark:text-white/80 dark:bg-gray-800/90': context.focused && !context.selected,
                                                    'bg-blue-100 text-blue-700 dark:bg-sky-800 dark:text-white/80': context.focused && context.selected,
                                                    'bg-blue-50 text-blue-700 dark:bg-sky-700 dark:text-white/80': !context.focused && context.selected,
                                                    'opacity-60 select-none pointer-events-none cursor-default': context.disabled
                                                }
                                            )
                                        }),
                                    }}
                                    id="parametros_taxa_servico"
                                    name="parametros_taxa_servico"
                                    placeholder="Selecione"
                                    value={parametrosTaxa}
                                    options={taxaOptions}
                                    onChange={e => {
                                        setParametrosTaxa(e.target.value)
                                    }}
                                    required
                                />
                        </div>

                        <div className="flex flex-col gap-0.5">
                            <label htmlFor="parametros_cancelamento" className={labelClass}>Quantidade de parcelas/mensalidades</label>
                            <span className={hintClass}>Para ter o contrato cancelado</span>
                            <InputText
                                className={fieldClass}
                                id="parametros_cancelamento"
                                name="parametros_cancelamento"
                                placeholder="ex: 2"
                                value={parametrosCancelamento}
                                onChange={e => setParametrosCancelamento(e.target.value)}
                                locale="pt-BR"
                                min={0}
                                max={4}
                                type="number"
                                required
                            />
                        </div>

                    <div className="w-full flex justify-end pt-2">
                        <Button
                            className="h-10 min-h-[2.5rem] min-w-[7rem]"
                            severity="info"
                            label="Salvar"
                            type="submit"
                            loading={loading}
                        />
                    </div>
                </form>
            </div>
        </AppCard>
    );
}
